import React, { useState, useEffect, useContext } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import AvatarDisplay from "components/shared-components/AvatarDisplay";
import { makeSelectCurrentUser } from "redux/selectors/Users";
import { useSelector } from "react-redux";
import messages from "views/loyalty-app/app-loyalty-views/translations";
import { useIntl } from "react-intl";
import { ROUTES } from "views/loyalty-app/app-loyalty-views/LoyaltyRoutes";
import { useHistory, useLocation } from "react-router-dom";
import routeToTitleMap from "./titleToRouteMap";
import { LoyaltyLayoutContext } from "../context";

const AvatarCustomStyle = {
  border: "3px solid white",
  boxShadow: "4px 4px 6px 0px #C4CDD866",
  boxShadowInset: "-2px -2px 9px 0px #D6DAE6 inset",
};

const HomeNavigation = () => {
  const currentUser = useSelector(makeSelectCurrentUser());
  const { formatMessage } = useIntl();

  return (
    <div className="d-flex w-100 loyalty-user-container">
      <AvatarDisplay
        image={currentUser?.contact_profile_picture}
        name={`${currentUser.first_name} ${currentUser.last_name}`}
        containerStyle={"loyalty-avatar__icon"}
        customStyle={AvatarCustomStyle}
      />
      <div>
        <h1 className="loyaly-user-container-text ml-3">
          {formatMessage(messages.homeGreeting, {
            name: currentUser.first_name,
          })}
        </h1>
        <p className="loyaly-user-container-message ml-3">
          {formatMessage(messages.homeMessage)}
        </p>
      </div>
    </div>
  );
};

const RegularNavigation = ({ title }) => {
  const { setPathTitle } = useContext(LoyaltyLayoutContext);
  const history = useHistory();

  const handleNavigation = () => {
    history.goBack();
    setPathTitle("");
  };

  return (
    <div className="loyalty-regular-navigation">
      <div className="loyalty-regular-navigation-container d-flex align-items-center w-100 mt-1">
        <button
          className="loyalty-regular-navigation-back-button"
          onClick={handleNavigation}
        >
          <ArrowLeftOutlined />
        </button>
        <h1 className="loyalty-regular-navigation-title">{title}</h1>
      </div>
    </div>
  );
};

const ProfileNavigation = () => {
  const currentUser = useSelector(makeSelectCurrentUser());

  return (
    <div className="loyalty-profile-navigation w-100">
      <div className="d-flex align-items-center w-100 mt-1">
        <AvatarDisplay
          name={`${currentUser.first_name} ${currentUser.last_name}`}
          containerStyle={"loyalty-profile__avatar"}
          image={currentUser?.contact_profile_picture}
          customStyle={AvatarCustomStyle}
        />
        <h1 className="loyalty-profile-navigation-title">
          {`${currentUser.first_name} ${currentUser.last_name}`}
        </h1>
      </div>
    </div>
  );
};

const TopNavigationBar = ({ setPath }) => {
  const location = useLocation();
  const { formatMessage } = useIntl();
  const CUSTOM_PATHS = [ROUTES.HOME, ROUTES.PROFILE];
  const [title, setTitle] = useState("");
  const { pathTitle } = useContext(LoyaltyLayoutContext);

  useEffect(() => {
    if (pathTitle) {
      setTitle(pathTitle);
    } else if (!CUSTOM_PATHS.includes(location.pathname)) {
      setTitle(routeToTitleMap(location.pathname, formatMessage));
    }
    setPath(location.pathname);
  }, [location]);

  const renderCustomNavigation = () => {
    switch (location.pathname) {
      case ROUTES.HOME:
        return <HomeNavigation />;
      case ROUTES.PROFILE:
        return <ProfileNavigation />;
      default:
        return <HomeNavigation />;
    }
  };

  return (
    <div className="d-flex">
      {CUSTOM_PATHS.includes(location.pathname) ? (
        renderCustomNavigation()
      ) : (
        <RegularNavigation title={title} />
      )}
    </div>
  );
};

export default TopNavigationBar;
